export default {
      id: "chevrons-right-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#chevrons-right",
      toString: function () {
        return this.url;
      }
    }